// Phase 14.5 Step 3 — DegradationProfile API client (full 5 CRUD + registry).
//
// Endpoints (Phase 14 backend, all already live):
//   GET    /api/degradation-profiles?page=1&page_size=20&tag=&name_search=
//   POST   /api/degradation-profiles
//   GET    /api/degradation-profiles/registry
//   GET    /api/degradation-profiles/:id
//   PUT    /api/degradation-profiles/:id
//   DELETE /api/degradation-profiles/:id    (204; 403 on seeded; 404 on missing)
//
// Step 2 shipped a minimal {list, registry} client; Step 3 extends it
// to the full surface the composer needs.
import { api as client } from "@/api/client";

const BASE = "/api/degradation-profiles";

export const degradationProfiles = {
    list: (params = {}) =>
        client.get(BASE, { params }).then((r) => r.data),
    get: (id) =>
        client.get(`${BASE}/${id}`).then((r) => r.data),
    create: (payload) =>
        client.post(BASE, payload).then((r) => r.data),
    update: (id, payload) =>
        client.put(`${BASE}/${id}`, payload).then((r) => r.data),
    remove: (id) =>
        client.delete(`${BASE}/${id}`).then((r) => r.data),
    registry: () =>
        client.get(`${BASE}/registry`).then((r) => r.data),
};

export default degradationProfiles;
